module.exports = __webpack_public_path__ + "../resources/img/line_checkbox_unselected_hover.4c4cf4df.svg";